import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

import router from './router'
import store from 'bestgob-core/store'

import * as svgicon from 'vue-svgicon';
import $ from 'jquery'
window.$ = $

import Vue2Filters from 'vue2-filters'
import VueGTag from 'vue-gtag'

import {renderImageFromAssets} from './assets/assets_utils'

Vue.config.productionTip = false
Vue.prototype.$renderImageFromAssets = renderImageFromAssets
Vue.prototype.$routing = router

Vue.use(svgicon, {
  classPrefix: 'AppIcon-',
});

Vue.use(Vue2Filters)

Vue.use(VueGTag, {
  config: {id: process.env.VUE_APP_GOOGLE_TAG_MANAGER_KEY}
})

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
